import { enableProdMode, LOCALE_ID, DEFAULT_CURRENCY_CODE, importProvidersFrom } from '@angular/core';

import { customCurrencyMaskConfig, HttpLoaderFactory } from './app/app.config';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { QRCodeModule } from 'angularx-qrcode';
import { NgChartsModule } from 'ng2-charts';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MaterialFileInputModule } from 'ngx-custom-material-file-input';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { shareIcons } from 'ngx-sharebuttons/icons';
import { provideShareButtonsOptions, withConfig } from 'ngx-sharebuttons';
import { WindowReferenceService } from './app/shared/services/window-reference.service';
import { CookieService } from 'ngx-cookie-service';
import { provideNgxMask } from 'ngx-mask';
import { provideEnvironmentNgxCurrency } from 'ngx-currency';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { httpInterceptorProviders } from './app/shared/interceptor';
import { CurrencyPipe, IMAGE_CONFIG } from '@angular/common';
import { PreloadAllModules, provideRouter, Routes, withInMemoryScrolling, withPreloading, withRouterConfig } from '@angular/router';
import { routes } from './app/app.routes';
import { AuthGuard } from './app/shared/guard';
import { YOUTUBE_PLAYER_CONFIG } from '@angular/youtube-player';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        AuthGuard,
        provideRouter(
            routes,
            withInMemoryScrolling({scrollPositionRestoration: 'top'}),
            withRouterConfig({ onSameUrlNavigation: 'ignore'}),
            withPreloading(PreloadAllModules)
        ),
        importProvidersFrom(BrowserModule,
        OverlayModule,
        NgxWebstorageModule.forRoot(),
        ReactiveFormsModule,
        MaterialFileInputModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgChartsModule,
        QRCodeModule,
        SlickCarouselModule),
        CurrencyPipe,
        httpInterceptorProviders,
        {
            provide: LOCALE_ID,
            useValue: "pt"
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useValue: 'BRL'
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' }
        },
        provideEnvironmentNgxCurrency(customCurrencyMaskConfig),
        provideNgxMask(),
        CookieService,
        WindowReferenceService,
        provideShareButtonsOptions(
        // Override default config
        withConfig({
            debug: true
        }),
        // Load the default share icons set (optional)
        shareIcons()),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: IMAGE_CONFIG,
            useValue: {
                disableImageSizeWarning: true,
                disableImageLazyLoadWarning: true
            }
        },
        {
            provide: YOUTUBE_PLAYER_CONFIG,
            useValue: {
              loadApi: false,
              disablePlaceholder: true
            }
        }
    ]
})
  .catch(err => console.error(err));
